import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Jan 03 2019
 * @author LZe
 */
import * as React from 'react';
import Button, { ButtonColor, ButtonSize } from '../../../controls/Button';
import Icon, { IconColor, IconType } from '../../../media/Icon';
import Tooltip from '../../../info/Tooltip';
import translate from '../../../i18n/translate';

var ExportToExcel =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ExportToExcel, _React$PureComponent);

  function ExportToExcel() {
    var _this;

    _classCallCheck(this, ExportToExcel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportToExcel).apply(this, arguments));

    _this.export = function (event) {
      var _ref;

      event.preventDefault();
      var params = _this.props.excelExportParams || {};
      /**
       * Formates values
       */

      params.processCellCallback = function (props) {
        var column = props.column,
            value = props.value;
        var colDef = column.getColDef(); // Normal and excel `valueFormatter` should have the same arguments.

        var normalizedParams = Object.assign({
          colDef: colDef,
          data: props.node ? props.node.data : {},
          node: props.node
        }, props);

        if (colDef.excel != null && colDef.excel.valueFormatter != null) {
          return colDef.excel.valueFormatter(normalizedParams);
        } else if (colDef.valueFormatter) {
          return colDef.valueFormatter(normalizedParams);
        }

        return value;
      };
      /**
       * Remove action column from export
       */


      params.columnKeys = (_ref = []).concat.apply(_ref, _toConsumableArray(_this.props.columnApi.getAllDisplayedColumns().map(function (column) {
        var colDef = column.getColDef(); // LOG-5461 custom solution to export final price hidden columns, because by default it's exporting only displayed columns

        if (column.getColId().endsWith('finalPrice')) {
          var finalPriceType = column.getColId().replace("_finalPrice", '_excel_finalPrice_type');
          var finalPrice = column.getColId().replace("_finalPrice", '_excel_finalPrice');
          return _this.props.columnApi.getAllColumns().filter(function (value) {
            return value.getColId() === finalPriceType || value.getColId() === finalPrice;
          });
        }

        if (colDef.excel && colDef.excel.hide) {
          return null;
        }

        return [column.getColId()];
      })));

      _this.props.api.exportDataAsExcel(params);
    };

    return _this;
  }

  _createClass(ExportToExcel, [{
    key: "render",
    value: function render() {
      return React.createElement(Tooltip, {
        overlay: React.createElement("div", null, translate('EXPORT_TO_EXCEL')),
        children: React.createElement("div", {
          style: {
            padding: '10px 0'
          }
        }, React.createElement(Button, {
          onClick: this.export,
          buttonColor: ButtonColor.Light,
          buttonSize: ButtonSize.Tiny,
          iconButton: true
        }, React.createElement(Icon, {
          iconType: IconType.exportToExcel,
          iconColor: IconColor.Secondary
        }))),
        placement: "top"
      });
    }
  }]);

  return ExportToExcel;
}(React.PureComponent);

export { ExportToExcel as default };